import styled from 'styled-components';
export const DOIConfirmationWrapper = styled.div.withConfig({
  displayName: "DOIConfirmationWrapperstyles__DOIConfirmationWrapper"
})(["align-items:center;display:flex;flex-direction:row;height:100%;justify-content:center;position:absolute;text-align:center;width:100%;"]);